import { Link } from 'react-router-dom';
import { StyledRatingChip } from 'src/shared/design-system/DishFirstCard';
import { DynamicImage } from 'src/shared/design-system/DynamicImage';
import styled, { keyframes } from 'styled-components';
import { Border, Colors, Font, Mixins, Spacing, Transition } from 'web-common/src/shared/styles';
import { RESULT_IMAGE_DIMENSIONS } from './consts';

export const ResultImage = styled(DynamicImage)`
  min-width: ${RESULT_IMAGE_DIMENSIONS}px;
  height: ${RESULT_IMAGE_DIMENSIONS}px;
  width: ${RESULT_IMAGE_DIMENSIONS}px;
  border-radius: ${Border.Radius.M};
`;

export const Container = styled(Link)`
  ${Mixins.Flex.center()}
  gap: ${Spacing.SINGLE};
  min-height: ${Spacing.QUADRUPLE};
  border-radius: ${Border.Radius.M};
  margin: 0 -${Spacing.THREE_QUARTERS};
  padding: 0 ${Spacing.THREE_QUARTERS};
  transition: background ${Transition.Time.BASE};

  &:hover {
    background: #fafafa;
    color: ${Colors.BLACK};
  }
`;

export const StaticContainer = styled.div`
  ${Mixins.Flex.set()}
  gap: ${Spacing.SINGLE};
  min-height: ${Spacing.QUADRUPLE};
  border-radius: ${Border.Radius.M};
  margin: 0 -${Spacing.THREE_QUARTERS};
  padding: 0 ${Spacing.THREE_QUARTERS};
`;

export const ImageContainer = styled.div`
  height: 100%;
`;

export const Title = styled.div`
  ${Mixins.Text.overflow()};
  text-overflow: ellipsis;
  ${Font.bySize(Font.Size.S, Font.Weight.BOLD)}
`;

export const SubTitle = styled.div`
  ${Mixins.Text.overflow()};
  ${Font.bySize(Font.Size.XXS, Font.Weight.NORMAL)}
  color: ${Colors.GRAY_DARK_10};
  text-overflow: ellipsis;
`;

export const InfoContainer = styled.div`
  ${Mixins.Flex.set()}
  flex: 1 1 100%;
  gap: ${Spacing.SINGLE};
`;

export const TextContainer = styled.div`
  ${Mixins.Flex.setColumn()}
  flex: 1 1 100%;
`;

export const moveLoadingGradient = keyframes`
0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
`;

export const LoadingBox = styled.div`
  animation: ${moveLoadingGradient} 1.6s ease infinite;
  background: linear-gradient(45deg, ${Colors.GRAY_LITE_20}, ${Colors.GRAY_LITE_30}, ${Colors.GRAY_LITE_20});
  background-size: 400% 400%;
  border-radius: ${Border.Radius.S};
`;

export const LoadingCuisineImage = styled(LoadingBox)`
  ${Mixins.Shape.square(Spacing.DOUBLE)}
`;

export const LoadingDishImage = styled(LoadingBox)`
  ${Mixins.Shape.square(Spacing.TRIPLE)}
`;

export const LoadingShefImage = styled(LoadingBox)`
  ${Mixins.Shape.circle(Spacing.TRIPLE)}
`;

export const LoadingTitle = styled(LoadingBox)`
  height: ${Spacing.SINGLE_QUARTER};
  margin-bottom: ${Spacing.QUARTER};
  width: 100%;
`;

export const LoadingTitleHalf = styled(LoadingTitle)`
  width: 50%;
`;

export const LoadingTitleTall = styled(LoadingTitle)`
  height: ${Spacing.DOUBLE_HALF};
`;

export const LoadingSubTitle = styled(LoadingBox)`
  height: ${Spacing.SINGLE};
  width: 100%;
`;

export const LoadingRating = styled(LoadingBox)`
  height: ${Spacing.SINGLE};
  width: ${Spacing.TRIPLE};
`;

export const TextChip = styled(StyledRatingChip)`
  box-shadow: none;
  background-color: #f5f5f5;
`;
